<template>
  <div>
    子组件1: {{ value }}
    <button @click="change">更改</button>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 100
    }
  },
  methods: {
    change () {
      // 1. v-model @input
      // this.$emit('input', 200)

      // 2. sync
      this.$emit('update:value', 200)
    }
  }
}
</script>
